import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { HelpCircle } from "untitledui-js-base";

interface UnavailableReportViewProps {
  message?: string;
}

export const UnavailableReportView = ({
  message
}: UnavailableReportViewProps) => {
  const { unit } = useUnitsPropertiesDictionary();
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="rounded-full bg-alpha-20 p-5">
          <HelpCircle size="20px" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <h1 className="font-bold">Report is not available</h1>
          <p className="text-center text-sm font-medium text-content-300">
            {message ||
              `Application was moved from a ${unit} where this data was not requested`}
          </p>
        </div>
      </div>
    </div>
  );
};
